import type { StatusTone } from '../../../design-system';
import type { WorkerProfileWorker } from './model';

type WorkerStatusPresentation = { label: WorkerProfileWorker['status']; tone: StatusTone };

const workerStatuses: Record<string, WorkerStatusPresentation> = {
  DRAFT: { label: '등록 중', tone: 'neutral' },
  '등록 중': { label: '등록 중', tone: 'neutral' },
  SCHEDULED: { label: '입사 예정', tone: 'info' },
  '입사 예정': { label: '입사 예정', tone: 'info' },
  ACTIVE: { label: '재직', tone: 'success' },
  재직: { label: '재직', tone: 'success' },
  ON_LEAVE: { label: '휴직', tone: 'warning' },
  LEAVE_OF_ABSENCE: { label: '휴직', tone: 'warning' },
  SUSPENDED: { label: '휴직', tone: 'warning' },
  휴직: { label: '휴직', tone: 'warning' },
  TERMINATED: { label: '종료', tone: 'neutral' },
  ENDED: { label: '종료', tone: 'neutral' },
  퇴직: { label: '종료', tone: 'neutral' },
  종료: { label: '종료', tone: 'neutral' },
  '퇴직 예정': { label: '퇴직 예정', tone: 'warning' },
};

export function workerStatusPresentation(status?: string, terminationDate?: string): WorkerStatusPresentation {
  const value = status?.trim();
  const presentation = workerStatuses[value?.toUpperCase() ?? ''] ?? { label: '상태 확인 필요', tone: 'neutral' };
  return presentation.label === '재직' && terminationDate
    ? workerStatuses['퇴직 예정']
    : presentation;
}
